import request from './request.js';

export const cronvmcrate = (params) => {
  return request({
    url: '/api/blade-admin/cronvmcrate/page',
    method: 'get',
    params
  })
}
